import React, { useCallback, useContext, useMemo } from 'react';
import { Img, svgSprite } from '../../../../hybrid/wrappers';
// import FooterLinkMobile from '../FooterLinkMobile/FooterLinkMobile';
import { footerInfoKz, footerInfoKrz, footerInfoUz, footerInfoRu } from '../../../store/components/initData';
import FooterMenu from '../../../../widgets/menu/single/FooterMenu';
import T from '../../../../common/components/T';
import defaultCss from './single-footer.module.scss';
import classNames from 'classnames';
import MoveUpButton from '../../../../widgets/moveUpButton/MoveUpButton';
import Link from 'next/link';
import { generateUniqueId, getDocumentByCountry } from '../../../../common/utils/utils';
import { useRouter } from 'next/router';
import UserContext, { UserProfileContext } from '../../../../common/utils/getContext';
const project = require('../../../../scripts/configs/project');

const SingleFooter = ({ OverFooter, compStyles, viewMoveUpBtn, officeBg }) => {
    const currentYear = new Date().getFullYear();
    const router = useRouter();
    const { profileData } = useContext(UserProfileContext);
    const { localization } = useContext(UserContext);

    const Wrapper = useCallback(
        ({ children }) => {
            if (OverFooter) {
                return <OverFooter>{children}</OverFooter>;
            } else {
                return children;
            }
        },
        [OverFooter]
    );
    const uzGeoId = 1512440;
    const krzGeoId = 1527747;
    const ruGeoId = 2017370;

    const topLevelDomain = typeof window !== 'undefined' && window.location.host.split('.').pop();
    const footerInfo =
        topLevelDomain === 'ru'
            ? footerInfoRu
            : topLevelDomain === 'kz'
            ? footerInfoKz
            : localization?.country?.id == uzGeoId
            ? footerInfoUz
            : localization?.country?.id == krzGeoId
            ? footerInfoKrz
            : localization?.country?.id == ruGeoId
            ? footerInfoRu
            : footerInfoKz;

    const isRegisterPage = router?.pathname === '/[lang]/auth/[...type]';

    const documentCountryTag = useMemo(() => {
        if (topLevelDomain == 'ru') {
            return 'ru';
        } else if (topLevelDomain == 'kz') {
            return 'kz';
        } else {
            if (profileData?.country?.country) {
                return profileData?.country?.country;
            }
            return localization?.country?.code;
        }
    }, [profileData, localization, topLevelDomain]);

    return (
        <Wrapper>
            <div
                className={classNames(
                    defaultCss.footerWrap,
                    isRegisterPage && defaultCss.footerWrapRegister,
                    officeBg && defaultCss.footerWrapOffice,
                    compStyles?.footerWrap
                )}
            >
                {/* <FooterLinkMobile /> */}
                <div
                    className={classNames(
                        defaultCss.footerInfoWrap,
                        isRegisterPage && defaultCss.footerWrapRegister,
                        compStyles?.footerInfoWrap
                    )}
                >
                    <div className={classNames(defaultCss.blockXl, defaultCss.footerInfo)}>
                        <div className={defaultCss.footerInfoContact}>
                            <Img
                                quality={100}
                                width={243}
                                height={60}
                                src='/logo.svg'
                                alt='Logo'
                                className={defaultCss.footerLogo}
                            />

                            {/* <A className={defaultCss.footerInfoPhone} href={`tel:${footerInfo.phone}`}>
                                {footerInfo.phone}
                            </A> */}
                            {/* <div className={defaultCss.footerInfoTime}>{footerInfo.timeWork}</div> */}
                            {footerInfo.subtitle && Array.isArray(footerInfo.subtitle)
                                ? footerInfo.subtitle.map((text) => (
                                      <div key={Math.random()} className={defaultCss.footerInfoSubtitle}>
                                          {text}
                                      </div>
                                  ))
                                : null}
                        </div>
                        <FooterMenu compStyles={defaultCss} topLevelDomain={topLevelDomain} />
                        {/* <div className={defaultCss.singleFooterSocialWrapper}> */}
                        {/* <div className={defaultCss.footerSocialTitle}>
                                <T page='/' textName='footer-SocialMedia' defaultStr='Социальные сети' />
                            </div> */}
                        {/* <div className={defaultCss.dev}>
                                <p className={defaultCss.devText}>
                                    <T textName='devText' defaultStr='Разработка' page='all' /> {' — '}
                                </p>
                                <A
                                    className={classNames(defaultCss.devLink, defaultCss.cursorPointer)}
                                    href={project?.developer?.link}
                                >
                                    {project?.developer?.text}
                                </A>
                            </div> */}
                        {/* </div> */}
                        <div className={defaultCss.footerSocial}>
                            {footerInfo.social.map((elem, idx) => (
                                <div
                                    key={`social${idx}`}
                                    // style={{ background: elem.background }}
                                    className={classNames(defaultCss.footerSocialIcon)}
                                    onClick={() => {
                                        window.open(elem.link, '_blank');
                                    }}
                                >
                                    {svgSprite(elem.type)}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            <div className={defaultCss.underFooter}>
                <div className={defaultCss.underFooterRights}>
                    <div className={defaultCss.underFooterRightsDiv}>
                        <p>
                            <T
                                textName='copyright-gt'
                                vars={{
                                    year: currentYear,
                                    company: project?.company
                                }}
                                defaultStr='© ${year} ${company}. All rights reserved'
                                page='all'
                            />
                        </p>
                    </div>
                    <div className={defaultCss.underFooterLinks}>
                        <div className={defaultCss.footerAccordionBodyItem2} key={generateUniqueId()}>
                            <Link
                                className={defaultCss.itemMenuStyle2}
                                target={'_blank'}
                                href={
                                    topLevelDomain === 'ru'
                                        ? '/docs/security_pay_bank_card_ru.pdf'
                                        : '/docs/security_pay_bank_card_com.pdf'
                                }
                                style={{ whiteSpace: 'unset' }}
                            >
                                <T textName='footer-link-ru-2' defaultStr='Политика безопасности при оплате банковской картой' />
                            </Link>
                        </div>
                        <div className={defaultCss.footerAccordionBodyItem2} key={generateUniqueId()}>
                            <Link
                                className={defaultCss.itemMenuStyle2}
                                target={'_blank'}
                                href={`/${getDocumentByCountry(documentCountryTag, 'confident')}`}
                                style={{ whiteSpace: 'unset' }}
                            >
                                <T textName='footer-link-ru-3' defaultStr='Положение о конфиденциальной информации' />
                            </Link>
                        </div>
                        {/* <div className={defaultCss.footerAccordionBodyItem2} key={generateUniqueId()}>
                            <Link
                                className={defaultCss.itemMenuStyle2}
                                target={'defaultCss'}
                                href={topLevelDomain === 'ru' ? '/docs/oferta_ru.pdf' : '/docs/oferta_com.pdf'}
                                style={{ whiteSpace: 'unset' }}
                            >
                                <T textName='footer-link-ru-5' defaultStr='Оферта' />
                            </Link>
                        </div>
                        <div className={defaultCss.footerAccordionBodyItem2} key={generateUniqueId()}>
                            <Link
                                className={defaultCss.itemMenuStyle2}
                                target={'_blank'}
                                href={
                                    topLevelDomain === 'ru'
                                        ? '/docs/distributor_agreement_ru.pdf'
                                        : '/docs/distributor_agreement_com.pdf'
                                }
                                style={{ whiteSpace: 'unset' }}
                            >
                                <T textName='footer-link-ru-71' defaultStr='Дистрибьюторское соглашение' />
                            </Link>
                        </div> */}
                    </div>
                </div>
            </div>
            {viewMoveUpBtn && <MoveUpButton />}
        </Wrapper>
    );
};

export default SingleFooter;
